<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Payment Method</h5>
      <br />
    </div>
    <b-card class="text-left">
      <p>
        <i>Created By</i>&nbsp;
        <b>{{items.created_by_username}}</b>
        | {{items.created_at | DateTime}}
      </p>
      <p v-if="items.updated_by_username">
        <i>Last Edited By</i>&nbsp;
        <b>{{items.updated_by_username}}</b>
        | {{items.updated_at | DateTime}}
      </p>
      <p v-else>
        <i>Last Edited By</i>&nbsp;
        <b>Empty</b>
        | Empty
      </p>
      <h5 class="font-weight-bold">Edit Payment Method</h5>
      <b-row class="mt-4">
        <b-col md="6">
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Payment Gateway Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.payment_gateway"
                  name="payment_gateway"
                  data-vv-as="Payment Gateway Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Payment Gateway Name"
                />
                <b-form-invalid-feedback
                  id="input-payment_gateway-feedback"
                >{{ veeErrors.first('payment_gateway') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Payment Method Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.method_name"
                  name="method_name"
                  data-vv-as="Payment Method Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Payment Method Name"
                />
                <b-form-invalid-feedback
                  id="input-method_name-feedback"
                >{{ veeErrors.first('method_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Display Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-model="items.display_name"
                  v-validate="'required'"
                  name="display_name"
                  data-vv-as="Display Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Display Name"
                />
                <b-form-invalid-feedback
                  id="input-display_name-feedback"
                >{{ veeErrors.first('display_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Additional Info (Bahasa)"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-model="items.additional_info_id"
                  v-validate="'required'"
                  name="additional_info_id"
                  data-vv-as="Additional Info (Bahasa)"
                  id="input-1"
                  class="form-control"
                  placeholder="Additional Info (Bahasa)"
                />
                <b-form-invalid-feedback
                  id="input-additional_info_id-feedback"
                >{{ veeErrors.first('additional_info_id') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Additional Info (English)"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-model="items.additional_info_en"
                  v-validate="'required'"
                  name="additional_info_en"
                  data-vv-as="Additional Info (English)"
                  id="input-1"
                  class="form-control"
                  placeholder="Additional Info (English)"
                />
                <b-form-invalid-feedback
                  id="input-additional_info_en-feedback"
                >{{ veeErrors.first('additional_info_en') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Type"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <vue-multiselect
                  v-model="items.type"
                  :options="all_type"
                  :preserve-search="true"
                  placeholder="Pick some"
                  label="description"
                  track-by="value"
                  v-validate="'required'"
                  name="type"
                  open-direction="bottom"
                  data-vv-as="Type"
                  :preselect-first="true"
                ></vue-multiselect>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('type') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            class="required"
            label="Payment Method Logo"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{image.name || 'Name'}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(500px x 500px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image"
                    name="image"
                    v-validate="'image|minimalDimensions:500,500|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeimage()"
                  />
                  <b-button
                    @click="$refs.image.click()"
                    v-show="!image && !items.logo"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="image || items.logo"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image.click()"
                    v-show="image || items.logo"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
      </b-row>
      <br />
      <h5 class="font-weight-bold">Parameter</h5>
      <div v-for="(input , k) in items.parameters" :key="k">
        <b-row align-v="center">
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Key"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-validate="'required'"
                v-model="input.key"
                :name="'key'+k"
                data-vv-as="Key"
                id="input-1"
                class="form-control"
                placeholder="Key"
              />
              <b-form-invalid-feedback id="input-key-feedback">{{ veeErrors.first('key'+k) }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label="Value"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              <input
                v-model="input.value"
                v-validate="'required'"
                :name="'value'+k"
                data-vv-as="Value"
                id="input-1"
                class="form-control"
                placeholder="Value"
              />
              <b-form-invalid-feedback id="input-value-feedback">{{ veeErrors.first('value'+k) }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-link
              style="text-decoration: none;"
              class="text-danger"
              @click="remove(k)"
              v-show="k || ( !k && items.parameters.length > 1)"
            >
              <i class="far fa-trash-alt"></i> Remove
            </b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-button
              block
              variant="outline-primary"
              @click="add(k)"
              v-show="k == items.parameters.length-1"
            >
              <i class="fas fa-plus"></i> Add More
            </b-button>
          </b-col>
        </b-row>
      </div>
      <br />

      <b-row v-for="(data , y) in items.payment_method_product_locations" :key="y">
        <b-col>
          <hr />
          <h5 class="font-weight-bold">{{data.product_location_name}}</h5>
          <b-form-group class="my-4" label="Status">
            <b-form-radio-group
              id="radio-group-2"
              v-validate="'required'"
              :name="'status'+y"
              :key="y"
              data-vv-as="Status"
              v-model="data.is_enable"
            >
              <b-form-radio :value="true">Enable</b-form-radio>
              <b-form-radio :value="false">Disable</b-form-radio>
            </b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('status'+y) }}</p>
          </b-form-group>
          <div v-for="(input , k) in data.parameters" :key="k">
            <b-row align-v="center">
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Key"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <input
                    v-validate="'required'"
                    v-model="input.key"
                    :name="'key'+y+k"
                    data-vv-as="Key"
                    id="input-1"
                    class="form-control"
                    placeholder="Key"
                  />
                  <b-form-invalid-feedback id="input-key-feedback">{{ veeErrors.first('key'+y+k) }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Value"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <input
                    v-validate="'required'"
                    v-model="input.value"
                    :name="'value'+y+k"
                    data-vv-as="Value"
                    id="input-1"
                    class="form-control"
                    placeholder="Value"
                  />
                  <b-form-invalid-feedback
                    id="input-value-feedback"
                  >{{ veeErrors.first('value'+y+k) }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-link
                  style="text-decoration: none;"
                  class="text-danger"
                  @click="removeProductParameter(y,k)"
                  v-show="k || ( !k && data.parameters.length > 1)"
                >
                  <i class="far fa-trash-alt"></i> Remove
                </b-link>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-button
                  block
                  variant="outline-primary"
                  @click="addProductParameter(y)"
                  v-show="k == data.parameters.length-1"
                >
                  <i class="fas fa-plus"></i> Add More
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="6">
          <b-button block variant="outline-primary" @click="modalProduct = !modalProduct">
            <i class="fas fa-plus"></i> Add More
          </b-button>
        </b-col>
      </b-row>
      <br />

      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'PaymentMethod'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-show="!image" v-if="items.logo" width height="400px" :src="items.logo" />
      <img v-show="image" v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
    <b-modal
      v-model="modalProduct"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      centered
      size="md"
      body-class="p-0 mb-n3"
    >
      <b-form-group>
        <b-form-checkbox-group
          v-model="selected"
          stacked
          buttons
          block
          button-variant="light"
          class="text-right"
          style="width:100%;height:100%;padding:0px;"
        >
          <b-form-checkbox
            v-for="(data,key) in product_location"
            :key="key"
            class="text-left text-primary font-weight-bold"
            @change="addProduct({name:data.product_name,id:data.id,key:key})"
            :value="data.id"
            :disabled="data.temp_is_used"
          >
            <!-- <label v-for="value in list_product" :key="value">
              <b-button :disabled="value.id == data.id">CEK</b-button>
            </label>-->
            {{data.product_name}}
          </b-form-checkbox>
          <!-- <b-form-checkbox
            class="text-left text-primary font-weight-bold"
            @change="addProduct('Shipment')"
            value="apple"
          >Shipment</b-form-checkbox>
          <b-form-checkbox
            class="text-left text-primary font-weight-bold"
            @change="addProduct('Paxel Market')"
            value="pineapple"
          >Paxel Market</b-form-checkbox>
          <b-form-checkbox
            class="text-left text-primary font-weight-bold"
            @change="addProduct('Rental Locker')"
            value="grape"
          >Rental Locker</b-form-checkbox>-->
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      modalProduct: false,
      loading: false,
      payment_gateway: "",
      method_name: "",
      display_name: "",
      type: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false,
      product_location: [],
      list_product: [],
      all_type: [],
      items: [],
      parameter: [
        {
          key: "",
          value: ""
        }
      ]
    };
  },

  beforeCreate() {
    const formData = new FormData();
    formData.append("payment_method_id", this.$route.params.id);
    this.$store.dispatch("PaymentMethodModule/getAllProductLocation", formData);
    this.$store.dispatch("PaymentMethodModule/getAllType");
    this.$store.dispatch(
      "PaymentMethodModule/getPaymentMethod",
      this.$route.params.id
    );
  },
  created() {
    this.$store.watch(
      state => state.PaymentMethodModule.product_location,
      (newValue, oldValue) => {
        this.product_location = newValue;
      }
    );
    this.$store.watch(
      state => state.PaymentMethodModule.all_type,
      (newValue, oldValue) => {
        this.all_type = newValue;
      }
    );
    this.$store.watch(
      state => state.PaymentMethodModule.payment_method_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    add(index) {
      this.items.parameters.push({
        key: "",
        value: ""
      });
    },
    remove(index) {
      this.items.parameters.splice(index, 1);
    },
    addProductParameter(index) {
      this.items.payment_method_product_locations[index].parameters.push({
        key: "",
        value: ""
      });
    },
    removeProductParameter(index, key) {
      this.items.payment_method_product_locations[index].parameters.splice(
        key,
        1
      );
    },
    addProduct(value) {
      this.product_location[value.key].temp_is_used = true;
      this.modalProduct = false;
      this.items.payment_method_product_locations.push({
        product_location_id: value.id,
        product_location_name: value.name,
        is_enable: null,
        parameters: [
          {
            key: "",
            value: ""
          }
        ]
      });
    },
    put() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("payment_gateway", this.items.payment_gateway);
          formData.append("method_name", this.items.method_name);
          formData.append("logo", this.image);
          formData.append("display_name", this.items.display_name);
          formData.append("additional_info_id", this.items.additional_info_id);
          formData.append("additional_info_en", this.items.additional_info_en);
          formData.append("type", this.items.type.value);
          if (this.items.parameters) {
            $.each(this.items.parameters, (index, value) => {
              formData.append("payment_method[parameter][sequence]", index);
              formData.append(
                `payment_method[parameter][${index}][key]`,
                value.key
              );
              formData.append(
                `payment_method[parameter][${index}][value]`,
                value.value
              );
            });
          }
          if (this.items.payment_method_product_locations) {
            $.each(
              this.items.payment_method_product_locations,
              (index, value) => {
                formData.append(
                  `payment_method[product_location][sequence]`,
                  index
                );
                formData.append(
                `payment_method[product_location][${index}][is_new]`,
                true
              );
                formData.append(
                  `payment_method[product_location][${index}][product_location_id]`,
                  value.product_location_id
                );
                formData.append(
                  `payment_method[product_location][${index}][is_enable]`,
                  value.is_enable
                );
                $.each(value.parameters, (key, data) => {
                  formData.append(
                    `payment_method[product_location][${index}][parameter][sequence]`,
                    key
                  );
                  formData.append(
                    `payment_method[product_location][${index}][parameter][${key}][key]`,
                    data.key
                  );
                  formData.append(
                    `payment_method[product_location][${index}][parameter][${key}][value]`,
                    data.value
                  );
                });
              }
            );
          }
          this.$store
            .dispatch("PaymentMethodModule/putPaymentMethod", {
              id: this.$route.params.id,
              formData
            })
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "PaymentMethod" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              var message = error.response.data.data.toString();
              console.log(message);
              this.$swal({
                type: "error",
                title: "Oops...",
                text: message,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style scoped>
.btn-light:disabled.disabled.active {
  background-color: #f9f9fb !important;
  color: #acacad !important;
  font-weight: normal !important;
}
.btn-light:hover {
  background-color: #f9f9fb !important;
}
</style>
